<template>
  <div>
    <el-button type="primary" icon="el-icon-circle-plus" @click="create" >Nouveau</el-button>
    <el-dialog title="Ajouter" :visible.sync="modal" >
      <node-version-form v-model="node" :dir="dir" @cancel="modal = false" @input="created" />
    </el-dialog>
  </div>
</template>

<script>
import {NodeVersion} from '../entity'
import NodeVersionForm from './NodeVersionForm'

export default {
  props: {
    dir: {
      type: NodeVersion,
      required: false
    }
  },
  data () {
    return {
      modal: false,
      node: new NodeVersion()
    }
  },
  methods: {
    create () {
      this.node = new NodeVersion()
      this.modal = true
    },
    created () {
      this.$emit('new')
      this.modal = false
    }
  },
  components: {
    NodeVersionForm
  }
}
</script>



// WEBPACK FOOTER //
// src/files/components/AddNode.vue